module.exports = __webpack_public_path__ + "apple-touch-icon-114x114.png?59665b5b0e47e055283403820d215c7f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-touch-icon-114x114.png
// module id = 138
// module chunks = 0